import { render, staticRenderFns } from "./ClientRewrite.vue?vue&type=template&id=f20fc3d8&scoped=true&"
import script from "./ClientRewrite.vue?vue&type=script&lang=js&"
export * from "./ClientRewrite.vue?vue&type=script&lang=js&"
import style0 from "./ClientRewrite.vue?vue&type=style&index=0&id=f20fc3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20fc3d8",
  null
  
)

export default component.exports